import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  width?: number;
  height?: number;
  stroke?: string;
}

const ChevronDownIcon: React.FC<Props> = ({
  width = 24,
  height = 24,
  stroke = '#475569'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);
export { ChevronDownIcon };
